import { BaseStateInterface } from './basestate.state';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { QuestionnaireConfig } from '../../@types/dto/questionnaire-config.model';
import { QuestionnaireConfigHttpService } from '@services/datasources/questionnaireConfig-http.service';

export interface QuestionnaireConfigModel extends BaseStateInterface {
    questionnaireConfig: QuestionnaireConfig | undefined;
}

export namespace QuestionnaireConfigAction {
    export class Activate {
        public static type = '[questionnaireConfig UI] Activate questionnaireConfig';

        constructor(public orgId: string, public entityId: string) {}
    }
}

@State<QuestionnaireConfigModel>({
    name: 'questionnaireConfig',
    defaults: {
        questionnaireConfig: undefined,
        isInit: false,
        isLoading: false,
        errors: [],
    },
})
@Injectable()
export class QuestionnaireConfigState {
    constructor(private questionnaireConfigService: QuestionnaireConfigHttpService) {}

    //----- store action -----//

    @Action(QuestionnaireConfigAction.Activate)
    activate(ctx: StateContext<QuestionnaireConfigModel>, action: QuestionnaireConfigAction.Activate) {
        this.questionnaireConfigService.get(action.orgId, action.entityId).subscribe((config) => {
            if (config) {
                ctx.patchState({
                    questionnaireConfig: config,
                    isInit: true,
                    isLoading: false,
                    errors: undefined,
                });
            } else {
                let errors = ctx.getState().errors;
                errors.push('Cannot fetch the questionnaire config');
                ctx.patchState({
                    questionnaireConfig: undefined,
                    isInit: true,
                    isLoading: false,
                    errors: errors,
                });
            }
        });
    }

    @Selector([QuestionnaireConfigState])
    static getStaticConfig(state: QuestionnaireConfigModel) {
        return state.questionnaireConfig;
    }
}
